import { uniqBy } from 'lodash'

export const has = (array: string[] = [], item = ''): boolean => {
  return array.indexOf(item) > -1
}

export const filterAndSortData = <T extends { name: string }>(data: T[]): T[] => {
  return uniqBy(data, 'name').sort((a, b) => a.name.localeCompare(b.name))
}
